import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b656ed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "range-slider app-range-slider" }
const _hoisted_2 = { style: { height: '60px' } }
const _hoisted_3 = { class: "range-slider__inputs" }
const _hoisted_4 = { class: "range-slider__input-block" }
const _hoisted_5 = { class: "range-slider__placeholder p-text-capitalize" }
const _hoisted_6 = { class: "range-slider__input-wrapper" }
const _hoisted_7 = ["min", "max", "value"]
const _hoisted_8 = { class: "js-size-dealer" }
const _hoisted_9 = { class: "range-slider__units" }
const _hoisted_10 = { class: "range-slider__input-block" }
const _hoisted_11 = { class: "range-slider__placeholder p-text-capitalize" }
const _hoisted_12 = { class: "range-slider__input-wrapper" }
const _hoisted_13 = ["min", "max", "value"]
const _hoisted_14 = { class: "js-size-dealer" }
const _hoisted_15 = { class: "range-slider__units" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_block_ui = _resolveComponent("app-block-ui")!
  const _directive_app_fit_canvas_to_container = _resolveDirective("app-fit-canvas-to-container")!
  const _directive_app_chart = _resolveDirective("app-chart")!
  const _directive_app_nouislider = _resolveDirective("app-nouislider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_block_ui, { blocked: _ctx.blocked }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("canvas", null, null, 512), [
            [_directive_app_fit_canvas_to_container],
            [_directive_app_chart, _ctx.chartOptions]
          ])
        ]),
        (_ctx.options.length > 1)
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "steps-slider",
              style: { marginTop: '3px' },
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSliderChange && _ctx.onSliderChange(...args)))
            }, null, 544)), [
              [_directive_app_nouislider, _ctx.sliderOptions]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_i18n_t, { keypath: "common.min" }),
              _createTextVNode(" : ")
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("input", _mergeProps({
                class: "range-slider__input js-size-receiver",
                type: "number",
                id: "input-1"
              }, _ctx.minAttrs, {
                min: _ctx.minOptionValue,
                max: _ctx.to,
                value: _ctx.from,
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChangeMinValue && _ctx.onChangeMinValue(...args)))
              }), null, 16, _hoisted_7),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.from), 1)
            ]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.unit), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_i18n_t, { keypath: "common.max" }),
              _createTextVNode(" : ")
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("input", _mergeProps({
                class: "range-slider__input js-size-receiver",
                type: "number",
                id: "input-2"
              }, _ctx.maxAttrs, {
                min: _ctx.from,
                max: _ctx.maxOptionValue,
                value: _ctx.to,
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChangeMaxValue && _ctx.onChangeMaxValue(...args)))
              }), null, 16, _hoisted_13),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.to), 1)
            ]),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.unit), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["blocked"])
  ]))
}